import { cloneDeepWith } from 'lodash';
import { DateObject } from 'react-multi-date-picker';

// The date pickers hand their selections back as DateObject instances, and a DateObject
// keeps everything it is -- calendar, locale, the date itself -- in private fields. Lodash
// clones an unknown class by taking its prototype and copying its own properties, which
// produces an object that passes `instanceof DateObject` but carries none of those fields,
// so the first method called on it (`.day`, `.toDate()`, `toJSON` through JSON.stringify)
// throws "attempted to get private field on non-instance". Copy dates through their own
// constructor instead, and let lodash clone everything else as usual.
const cloneFormValue = (value) => (value instanceof DateObject ? new DateObject(value) : undefined);

/** Deep clone of form state that keeps picked dates usable. Use instead of `cloneDeep`. */
export const cloneFormState = (state) => cloneDeepWith(state, cloneFormValue);
